// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"9d90c4fd","250":"2a1dbf09","407":"7db22bc6","436":"cd0781a3","453":"f394a27d","455":"2b9dbaca","501":"e612acae","595":"a6096117","606":"f4e56ec9","691":"b66a3e38","821":"88969975","880":"a621142b","925":"1838c3b0","969":"201ebef9"}[chunkId] + ".chunk.js";
};